export enum FontOpacity {
    HEADING = 0.9,
    SUB_HEADING = 0.7,
    BODY_TEXT = 0.5,
    BODY_TEXT_LIGHTER = 0.3,
}
